module.exports = __webpack_public_path__ + "static/media/mostrarMapasDisabled.35aefa9b.svg";